export default __webpack_public_path__ + "static/media/ic_weather_9.37780ac4.svg";